import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { EditingDevice, WidgetDeviceView } from 'app/campaign/widgets.model';

@Component({
  selector: 'app-toggle-device-button',
  templateUrl: './toggle-device-button.component.html',
  styleUrl: './toggle-device-button.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ToggleDeviceButtonComponent {
  @Output() updateEditingDevice = new EventEmitter();
  @Input() isV2 = false;
  @Input() set setCurrentDeviceView(currentDeviceView) {
    if (currentDeviceView) {
      this.currentDeviceView = currentDeviceView;
      this.initializeCurrentEditingDevice();
    }
  }
  @Input() component: any;
  @Input() isMobileFirst: boolean;
  @Input() mobileEqualsDesktop: boolean;
  @Input() set disableMobileEditingDevice(value: boolean) {
    this._disableMobileEditingDevice = value;
    if (value && this.currentDevice === EditingDevice.Mobile) {
      this.currentDevice = EditingDevice.Any;
      this.updateEditingDevice.emit({ skipEmitting: true, currentDevice: this.currentDevice });
    }
  }
  public get disableMobileEditingDevice(): boolean {
    return this._disableMobileEditingDevice;
  }
  private _disableMobileEditingDevice = false;
  public EditingDevices = EditingDevice;
  public WidgetDeviceViews = WidgetDeviceView;
  public currentDeviceView: WidgetDeviceView;
  public currentDevice: EditingDevice;

  public initializeCurrentEditingDevice(): void {
    if (this.disableMobileEditingDevice) {
      this.currentDevice = EditingDevice.Any;
    } else if (
      this.currentDeviceView === WidgetDeviceView.Mobile &&
      (!this.isMobileFirst || !this.mobileEqualsDesktop)
    ) {
      this.currentDevice = EditingDevice.Mobile;
    } else {
      this.currentDevice = EditingDevice.Any;
    }
    this.updateEditingDevice.emit({ skipEmitting: true, currentDevice: this.currentDevice });
  }

  public selectDevice(device: EditingDevice): void {
    this.currentDevice = device;
    this.updateEditingDevice.emit({ currentDevice: this.currentDevice });
  }
}
